import domContentLoaded from 'dom-content-loaded';
import $, { each } from 'jquery';

const initOffsets = () => {
	const offsets = {
		'footerOffset': parseInt($('.js-scroll-hide-trigger').offset().top), //フッターの一番上の位置
		'windowHeight': parseInt($(window).height())
	}
	return offsets;
}

const scrollHide = (offsets) => {
	const scrollTop = $(window).scrollTop()
	const triggerOffset = parseInt(offsets.footerOffset - offsets.windowHeight * 0.66 - scrollTop);
	if (triggerOffset >= 0) {
		$('.js-scroll-hide-button').each((index, element) => {
			$(element).removeClass('is-hide');
		});
	} else {
		$('.js-scroll-hide-button').each((index, element) => {
			$(element).addClass('is-hide');
		});
	}
}

export default () => {
	let offsets;
	$(window).on({
		'load': () => {
			offsets = initOffsets();
			scrollHide(offsets)
		},
		'resize': () => {
			offsets = initOffsets();
			scrollHide(offsets)
		},
		'scroll': () => {
			offsets = initOffsets();
			scrollHide(offsets)
		},
	})
};
